/**
 * Represents an empty/default GUID (all zeros)
 */
export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';

/**
 * Checks if a GUID string is empty (all zeros) or undefined
 * @param guid - The GUID string to check
 * @returns true if the GUID is empty or undefined, false otherwise
 */
export const isEmptyGuid = (guid: string | undefined): boolean => {
  return !guid || guid === EMPTY_GUID;
};

/**
 * Checks if a GUID string is valid (not empty and not undefined)
 * @param guid - The GUID string to check
 * @returns true if the GUID is valid, false otherwise
 */
export const isValidGuid = (guid: string | undefined): boolean => {
  return !isEmptyGuid(guid);
};
